import { gql } from '@apollo/client';

export interface CompleteEventRequest {
  completeEventRequest: {
    uuid: string;
    id: string;
  };
}

export const COMPLETE_EVENT_REQUEST = gql`
  mutation($requestId: String!, $data: completeEventRequestData!) {
    completeEventRequest(requestId: $requestId, data: $data) {
      uuid
      id
    }
  }
`;
